import FieldIcon from "../../../../fields3/generic/icon/icon"
import FieldConfig from "../../../../fields3/proto/field-config"
import Project from "../../../../model2/project/project"
import FieldProjectColorIcon_Editable from "./render/editable"
import FieldProjectColorIcon_Popover from "./components/popover/popover"

export default class FieldProjectColorIcon extends FieldIcon {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Color / Icon"
        this.icon               = 'i5-color'


        this.components.PopoverMenu     = FieldProjectColorIcon_Popover

        this.renderComponents.editable  = FieldProjectColorIcon_Editable

    }

    canEdit(model:Project):boolean {
        return model.acl.canChangeIcon
    }

    getViewValue(model:any) {
        return {
            color       : _.get(model, 'color', null),
            projectIcon : _.get(model, 'projectIcon', null),
        }
    }

}